/**
 * transmittalsApi — client for AISC §1.7.0 Phase 3 (Form F-1.7.0).
 */

import ApiCall from "./apicall";

const ALLOWED_TRANSITIONS = {
  DRAFT:     ["SENT", "CANCELLED"],
  SENT:      ["RETURNED", "CANCELLED"],
  RETURNED:  ["CLOSED", "CANCELLED"],
  CLOSED:    [],
  CANCELLED: [],
};

export const ALLOWED_SENT_VIA = ["EMAIL", "MAIL", "COURIER", "HAND_DELIVERY", "OTHER"];

export const ALLOWED_ACTIONS = [
  "APPROVAL", "APPROVED_AS_SUBMITTED", "APPROVED_AS_NOTED",
  "YOUR_USE", "AS_REQUIRED", "RETURNED_AFTER_LOAN",
  "REVIEW_AND_COMMENT", "RESUBMIT", "SUBMIT", "RETURNED", "CHANGE_ORDER",
];

export const ALLOWED_RETURN_ACTIONS = [
  "APPROVED_AS_SUBMITTED", "APPROVED_AS_NOTED",
  "RESUBMIT", "RETURNED_AFTER_LOAN", "OTHER",
];

export const ALLOWED_ITEM_TYPES = [
  "DRAWING", "LETTER", "PRINT", "CHANGE_ORDER",
  "PLAN", "SAMPLE", "SPECIFICATION", "OTHER",
];

export function allowedTransmittalTransitions(status) {
  return ALLOWED_TRANSITIONS[status] || [];
}

export async function listTransmittals(params = {}) {
  const qs = new URLSearchParams();
  if (params.job_id) qs.set("job_id", String(params.job_id));
  if (params.status) qs.set("status", params.status);
  if (params.limit) qs.set("limit", String(params.limit));
  const r = await ApiCall.get(`/transmittal${qs.toString() ? `?${qs}` : ""}`);
  return r.data?.rows || [];
}

export async function getTransmittal(id) {
  const r = await ApiCall.get(`/transmittal/${id}`);
  return r.data;
}

export async function createTransmittal(payload) {
  const r = await ApiCall.post("/transmittal", payload);
  return r.data;
}

export async function updateTransmittal(id, payload) {
  const r = await ApiCall.patch(`/transmittal/${id}`, payload);
  return r.data;
}

export async function addTransmittalItems(id, items) {
  const r = await ApiCall.post(`/transmittal/${id}/items`, { items });
  return r.data;
}

export async function removeTransmittalItem(id, itemId) {
  const r = await ApiCall.delete(`/transmittal/${id}/items/${itemId}`);
  return r.data;
}

export async function sendTransmittal(id) {
  const r = await ApiCall.post(`/transmittal/${id}/send`, {});
  return r.data;
}

export async function returnTransmittal(id, payload) {
  const r = await ApiCall.post(`/transmittal/${id}/return`, payload);
  return r.data;
}

export async function closeTransmittal(id) {
  const r = await ApiCall.post(`/transmittal/${id}/close`, {});
  return r.data;
}

export async function cancelTransmittal(id, cancellation_reason) {
  const r = await ApiCall.post(`/transmittal/${id}/cancel`, { cancellation_reason });
  return r.data;
}
